import { render, staticRenderFns } from "./ManageTxItemMemberForm.vue?vue&type=template&id=ecaa036c&"
import script from "./ManageTxItemMemberForm.vue?vue&type=script&lang=js&"
export * from "./ManageTxItemMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./ManageTxItemMemberForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecaa036c')) {
      api.createRecord('ecaa036c', component.options)
    } else {
      api.reload('ecaa036c', component.options)
    }
    module.hot.accept("./ManageTxItemMemberForm.vue?vue&type=template&id=ecaa036c&", function () {
      api.rerender('ecaa036c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManageTxItemMemberForm.vue"
export default component.exports